// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2OjRs","footer":"ModalInfo_footer__3boqK"};